import React, { Component, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';

interface ICardProps {
	children: ReactNode;
	className: string;
	title: string;
}

export default class Card extends Component<ICardProps> {
	render() {
		const { children, className, title } = this.props;

		const cardClassNames = classNames(className, styles.card);

		return (
			<div className={cardClassNames}>
				<div className={styles.cardTitle}>{title}</div>
				<div className={styles.cardContent}>{children}</div>
			</div>
		);
	}
}
